<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Update Vendor Details</span>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">Update Vendor Details</h2>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h5 class="font-weight-medium mb-3 mb-md-4">Location: {{displayPark}}</h5>
    </div>

    <!-- form start -->
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
        <!-- ROOT CAUSE FIX: Removed ngb-panel + ng-template ngbPanelContent to prevent blank page issues -->
        <ngb-accordion [activeIds]="activeIds" class="form_accordion">
            <!-- Name and Branding Section -->
            <div class="mb-4 mb-md-5">
                <h5 class="mb-3 mb-md-4 font-weight-medium">Name and Branding</h5>
                <div class="row row-gap-4">
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" formControlName="FoodCourtVendorName" id="name" class="form-control"
                                    placeholder="Name" [(ngModel)]="foodcourt.FoodCourtVendorName">
                                <label>Name</label>
                            </div>
                            <div *ngIf="myForm.get('FoodCourtVendorName').invalid && myForm.get('FoodCourtVendorName').touched"
                                class="small text-danger">
                                <div *ngIf="myForm.get('FoodCourtVendorName').errors?.required">Name is required</div>
                                <div *ngIf="myForm.get('FoodCourtVendorName').errors?.maxlength">The name may not be
                                    longer
                                    than 100
                                    charecters</div>
                            </div>
                        </div>

                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <select class="form-control" formControlName="FoodCourtId"
                                    [(ngModel)]=foodcourt.FoodCourtId>
                                    <option value="">Food Court</option>
                                    <option value="{{foodcourt.foodCourtId}}" *ngFor="let foodcourt of foodCourtList">
                                        {{foodcourt.foodCourtName}}
                                    </option>
                                </select>
                                <label>Food Court</label>
                            </div>
                            <div *ngIf="myForm.get('FoodCourtId').invalid && myForm.get('FoodCourtId').touched"
                                class="small text-danger">
                                <div *ngIf="myForm.get('FoodCourtId').errors?.required">Food Court is required
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="d-flex align-items-center justify-content-between upload_field"
                                (click)="uploadImages.click()">
                                <span>Upload Images</span>
                                <svg-icon src="../../../assets/images/icons/upload.svg"></svg-icon>
                            </div>
                            <input onclick="this.value = null" formControlName="file" id="file" type="file"
                                class="d-none" multiple accept=".png, .jpg, .jpeg" (change)="onFileChange($event)"
                                #uploadImages>
                            <div *ngIf="myForm.get('file').invalid && myForm.get('file').touched"
                                class="small text-danger">
                                <div *ngIf="myForm.get('file').errors?.required">File is required</div>
                            </div>
                        </div>


                        <div class="col-12" *ngIf="images.length">
                            <div class="row row-gap-3">
                                <div class="col-12 col-md-6 col-lg-4 col-xl-3"
                                    *ngFor='let image of images; let i = index;'>
                                    <div class="uploaded_images">
                                        <img [src]="image.imgBase64">
                                        <!-- <span class="crop_icon" *ngIf="!image.cropped" (click)="openModal(content, i)">
                                            <svg-icon src="../../../assets/images/icons/crop.svg"></svg-icon>
                                        </span> -->
                                        <span class="remove_icon" (click)="removeImage(i)">
                                            <svg-icon src="../../../assets/images/icons/close.svg"></svg-icon>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="row row-gap-3">
                                <div class="col-12 col-md-6 col-lg-4 col-xl-3"
                                    *ngFor='let image of this.vendorDetails.data?.foodCourtVendorPhotos; let i = index;'>
                                    <div class="uploaded_images">
                                        <img [src]="image.foodCourtVendorPhotoPath">
                                        <!-- <span class="crop_icon" *ngIf="!image.cropped" (click)="openModal(content, i)">
                                            <svg-icon src="../../../assets/images/icons/crop.svg"></svg-icon>
                                        </span> -->
                                        <span class="remove_icon" (click)="removeImageOld(i)">
                                            <svg-icon src="../../../assets/images/icons/close.svg"></svg-icon>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <ng-template #content let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title">Image Cropper</h4>
                                <button type="button" class="close" aria-label="Close" (click)="closeModal()">
                                    <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
                                </button>
                            </div>
                            <div class="modal-body px-3">
                                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                                    [aspectRatio]="4 / 3" [cropperStaticWidth]="200" [cropperStaticHeight]="150"
                                    format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
                                    (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"
                                    output="blob"></image-cropper>
                            </div>
                            <div class="modal-footer border-light">
                                <button type="button" class="btn btn-clear" (click)="closeModal()">Cancel</button>
                                <button type="button" class="btn btn-primary" (click)="SaveCropedImage()">Crop</button>
                            </div>
                        </ng-template> -->
                    </div>
            </div>
            <!-- Days of Operation Section -->
            <div class="mb-4 mb-md-5 border-top border-light pt-4 pt-md-5">
                <h5 class="mb-3 mb-md-4 font-weight-medium">Days of Operation</h5>
                <div class="row row-gap-4">

                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <select class="form-control" formControlName="FromDaysOperation"
                                    [(ngModel)]="foodcourt.FromDaysOperation">
                                    <option value="">From</option>
                                    <option value="{{dayf.id}}" *ngFor="let dayf of daysOfOperation">{{dayf.name}}
                                    </option>
                                </select>
                                <label>From</label>
                            </div>
                            <div *ngIf="myForm.get('FromDaysOperation').invalid && myForm.get('FromDaysOperation').touched"
                                class="small text-danger">
                                <div *ngIf="myForm.get('FromDaysOperation').errors?.required">From days is required
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <select class="form-control" formControlName="ToDaysOperation"
                                    [(ngModel)]="foodcourt.ToDaysOperation">
                                    <option value="">To</option>
                                    <option value="{{dayt.id}}" *ngFor="let dayt of daysOfOperation">{{dayt.name}}
                                    </option>
                                </select>
                                <label>To</label>
                            </div>
                            <div *ngIf="myForm.get('ToDaysOperation').invalid && myForm.get('ToDaysOperation').touched"
                                class="small text-danger">
                                <div *ngIf="myForm.get('ToDaysOperation').errors?.required">To days is required</div>
                            </div>
                        </div>

                    </div>
            </div>
            <!-- Time of Operation Section -->
            <div class="mb-4 mb-md-5 border-top border-light pt-4 pt-md-5">
                <h5 class="mb-3 mb-md-4 font-weight-medium">Time of Operation</h5>
                <div class="row row-gap-4">
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                                    style="position: relative;" container="body" [ngbPopover]="popContent1"
                                    triggers="manual" #p1="ngbPopover" (click)="openPopover(p1)" placement="bottom"
                                    popoverClass='starttime-popover' (click)="enterName('time')">
                                    <input type="text" [ngClass]="time?'textbox-onselect':'textbox-style'"
                                        class="search-line pl-4 placeholder-text form-control" placeholder="From Time"
                                        formControlName="FromTimeOperation" (click)="enterName('time')">
                                    <label class="form-lable-time">From Time</label>
                                    <ng-template #popContent1>
                                        <div class="rectangle-copy-5">
                                            <label class="start-time pl-4 pt-3">From Time</label>
                                            <div class="pl-3 pr-4 pt-1">
                                                <ngb-timepicker [(ngModel)]="startTime"
                                                    [ngModelOptions]="{standalone: true}"
                                                    formControlName="FromTimeOperation1" name="strtTime"
                                                    [meridian]="meridian" (ngModelChange)="onTimeChange($event)"
                                                    [minuteStep]="15"></ngb-timepicker>
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>
                                <!-- <label>From Time</label> -->
                            </div>
                            <div *ngIf="myForm.get('FromTimeOperation').invalid && myForm.get('FromTimeOperation').touched"
                                class="small text-danger">
                                <div *ngIf="myForm.get('FromTimeOperation').errors?.required">From Time is required
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <div (clickOutside)="onClickedOutsideTo($event)" [autoClose]="'outside'"
                                    style="position: relative;" container="body" [ngbPopover]="popContent2"
                                    triggers="manual" #p2="ngbPopover" (click)="openPopoverTo(p2)" placement="bottom"
                                    popoverClass='endtime-popover' (click)="enterName('time')">
                                    <input type="text" [ngClass]="time?'textbox-onselect':'textbox-style'"
                                        class="search-line pl-4 placeholder-text form-control" placeholder="To Time"
                                        formControlName="ToTimeOperation" (click)="enterName('time')">
                                    <label class="form-lable-time">To Time</label>
                                    <ng-template #popContent2>
                                        <div class="rectangle-copy-5">
                                            <label class="start-time pl-4 pt-3">To Time</label>
                                            <div class="pl-3 pr-4 pt-1">
                                                <ngb-timepicker [(ngModel)]="endTime"
                                                    [ngModelOptions]="{standalone: true}"
                                                    formControlName="ToTimeOperation1" name="strtTime"
                                                    [meridian]="meridian" (ngModelChange)="onTimeChangeTo($event)"
                                                    [minuteStep]="15"></ngb-timepicker>
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>
                                <!-- <label>To Time</label> -->
                            </div>
                            <div *ngIf="myForm.get('ToTimeOperation').invalid && myForm.get('ToTimeOperation').touched"
                                class="small text-danger">
                                <div *ngIf="myForm.get('ToTimeOperation').errors?.required">To Time is required</div>
                            </div>
                        </div>
                    </div>
            </div>
        </ngb-accordion>
        <div
            class="py-3 py-md-4 border-top border-light mt-3 mt-md-4 d-flex align-items-center justify-content-end column-gap-3">
            <button class="btn btn-clear text-muted" type="button" (click)="goToListPage()">Cancel</button>
            <button class="btn btn-primary" type="submit">Update</button>
        </div>
    </form>
    <!-- form end -->
</div>